// 保加利亚语
const bg = {
  common: {
    notSupport: 'Вашият браузър не поддържа режим на цял екран',
    loadFail: 'Зареждането на темата не бе успешно',
    noPermission: 'За съжаление нямате разрешение за достъп до тази страница',
    backHome: 'Върнете се към началната страница',
    noExit: 'Страницата, която се опитвате да отворите, не съществува',
    serverError: 'За съжаление в сървъра възникна грешка',
    slide: 'Плъзнете надясно',
    veryHigh: 'Много високо',
    high: 'Високо',
    target: 'Цел',
    urgentLow: 'Много ниско',
    agpNoData: 'AGP отчетът изисква поне 5 дни данни за генериране',
    noDataStr: 'Няма данни',
    setting: 'Настройка',
    personInfo: 'Основна информация',
    updatePwd: 'Промяна на паролата',
    upHead: 'Качване на снимки',
    inRange: 'В обхват',
    normal: 'Нормално',
    low: 'Ниско',
    previous: 'Предишен',
    next: 'Следващ',
    search: 'Търсене',
    reset: 'Нулиране',
    cancel: 'Отказ',
    ok: 'ОК',
    confirm: 'Потвърдете',
    save: 'Запазване',
    submit: 'Изпратете',
    successful: 'Успешно',
    pleaseEnter: 'Моля, въведете',
    pleaseSelect: 'Моля изберете',
    success: 'Успех',
    confirmLogout: 'Сигурни ли сте, че искате да излезете?',
    updateSuccessed: 'Актуализацията успешна',
    warning: 'Предупреждение',
    date: 'Дата',
    start: 'Старт',
    end: 'Край',
    sevenDays: '7 дни',
    fourteenDays: '14 дни',
    thirtyDays: '30 дни',
    signOut: 'Излезте',
    personalInformation: 'Лична информация',
    email: 'Имейл',
    name: 'Име',
    mobile: 'Мобилен',
    dateOfBirth: 'Дата на раждане',
    gender: 'Пол',
    diabeteType: 'Тип диабет',
    dateOfDignose: 'Година на диагноза',
    remarks: 'Забележки',
    optionMale: 'мъжки',
    optionFemale: 'женски',
    optionUnknow: 'Предпочитам да не заявявам',
    noDiabetes: 'Няма диабет',
    diabeteTypeI: 'Тип I',
    diabeteTypeII: 'Тип II',
    diabeteSpecial: 'Специален',
    diabeteGestational: 'Гестационен диабет',
    diabeteOthers: 'други',
    ruleMsgEmail: 'Моля, въведете имейл',
    ruleMsgName: 'Моля, въведете име',
    ruleMsgMobile: 'Моля, въведете мобилен телефон',
    ruleMsgBirthday: 'Моля, изберете рожден ден',
    ruleMsgSex: 'Моля, изберете пол',
    ruleMsgDiabeteType: 'Моля, изберете тип диабет',
    ruleMsgDateOfDignose: 'Моля, изберете година на диагностициране',
    ruleMsgRemarks: 'Моля, въведете забележки',
    ruleMsgCorrectMobile: 'Моля, въведете правилния мобилен телефон',
    oldPassword: 'Стара парола',
    newPassword: 'Нова парола',
    confirmPassword: 'Потвърдете паролата',
    ruleMsgOldPassword: 'Моля, въведете старата парола',
    ruleMsgNewPassword: 'Моля, въведете нова парола',
    ruleMsgConfirmPassword: 'Моля, потвърдете паролата',
    passwordInconsistent: 'Двете въведени пароли са непоследователни',
    passwordModifySuccessed: 'Вашата парола е нулирана, моля влезте отново!',
    monday: 'пн',
    tuesday: 'вт',
    wednesday: 'ср',
    thursday: 'чт',
    friday: 'пт',
    saturday: 'сб',
    sunday: 'слънце',
    sn: 'SN',
    startDate: 'Начална дата',
    days: 'дни',
    pdfDate: 'Цел',
    close: 'близо',
    // inputTip: 'Моля, въведете ключови думи за търсене',
    inputTip: 'Моля, въведете кл...',
    polarization: 'Устройството се инициализира',
    hour: 'ч',
    minutes: 'мин',
    seconds: 'сек',
    reportDownLoadTip: 'Вашият отчет не е генериран от 5 дни.',
    age: 'възраст',
    goal: 'Цел',
    expired: 'сензор изтекъл',
    lastTime: 'Последно опреснено време',
    timeZone: 'Часова зона'
  },
  route: {
    login: 'Вход',
    forget: 'Забравена парола',
    home: 'Начало',
    glucoseReport: 'Доклад за глюкоза',
    sessionReport: 'Доклад от сесията',
    eventList: 'Списък със събития',
    followerList: 'Списък с проследяващи',
    followerListQ: 'Заявка за проследяващ',
    settings: 'Настройки',
    profile: 'Профил'
  },
  login: {
    rememberMe: 'Запомни ме',
    forgetPassword: 'Забравете паролата',
    agree: 'Вход означава съгласие с FurCarer',
    privacyPolicy: 'Политика за поверителност',
    CGMUser: 'Потребител на CGM',
    follower: 'Проследяващ',
    ruleMsgPassword: 'Моля, въведете парола',
    login: 'Вход',
    phonePlacehold: 'Моля, въведете телефонен номер',
    codePlacehold: 'Моля, въведете кода за потвърждение',
    codePlaceholdInput: 'Моля, въведете t...',
    phoneTip: 'По телефона',
    emialTip: 'По имейл',
    codeTip: 'Вземете код за потвърждение',
    reGetTip: 'Повторно придобиване'
  },
  layout: {
    collapseUp: 'Скриване на менюто',
    collapseDown: 'Разширете менюто',
    refresh: 'Опресняване',
    backHome: 'Начало',
    helpCenter: 'Помощен център',
    fullScreen: 'Цял екран'
  },
  forget: {
    ruleMsgCode: 'Моля, въведете код',
    sendCode: 'Изпратете код',
    tipsMsgSendSuccess: 'Кодът за потвърждение беше изпратен успешно!',
    tipsMsgModifySuccess: 'Успешна промяна на паролата'
  },
  home: {
    title: 'FurCarer Portal',
    todaysGlucose: 'Глюкоза днес',
    todaysOverview: 'Общ преглед днес',
    maxGlucose: 'Макс. глюкоза',
    minGlucose: 'Мин. глюкоза',
    avgGlucose: 'Ср. глюкоза',
    maxmumVariation: 'Максимална вариация',
    glucose: 'Глюкоза',
    tir: 'Зелена зона',
    latestGlucose: 'Най-новата глюкоза',
    todayPercentage: '% от днес в различен диапазон',
    fourHour: '4 часа',
    eightHour: '8 часа',
    twelveHour: '12 часа',
    twentyFourHour: '24 часа',
    glucoseOnly: 'Само глюкоза',
    sessionOverview: 'Преглед на сесията',
    glocuseMetrics: 'Глюкозни показатели',
    agp: 'AGP',
    dailyGlucose: 'Дневна глюкоза',
    sessionGlucose: 'Сесия Глюкоза',
    standTir: 'Стандартен TIR',
    customTir: 'Персонализиран TIR',
    cancleGz: 'Прекратете следенето',
    cancleText: 'Искате ли да спрете да следвате текущия потребител?',
    helpCenterTip: 'Функцията все още не е отворена'
  },
  glucoseReport: {
    statics: 'Статика',
    sixHour: '6 часа ТИР',
    avgGlucose: 'Средна глюкоза',
    maxGlucose: 'Максимална глюкоза',
    minGlucose: 'Мин. глюкоза',
    cv: 'CV',
    high: 'Числа на високи',
    low: 'Числа на ниски',
    normal: 'Нормални числа',
    tir: 'Зелена зона',
    estimatedA1c: 'Установен A1c',
    min: 'Мин',
    avg: 'Ср',
    max: 'Макс',
    maxVariation: 'Максимална вариация'
  },
  glucoseProfile: {
    avg: 'Ср',
    sd: 'SD',
    cv: 'CV'
  },
  eventList: {
    all: 'Всички',
    bg: 'БГ',
    meal: 'Храна',
    sport: 'Спорт',
    insulin: 'Инсулин',
    alert: 'Аларма',
    eventType: 'Тип събитие',
    description: 'Описание',
    note: 'Забележка',
    highAlert: 'Аларма предупреждение',
    calibration: 'Калибриране',
    meds: 'лекарства',
    time: 'време',
    detail: 'детайл',
    weigt: 'Тегло'
  },
  followerList: {
    title: 'Мониторинг на потребителите',
    tabTitle: 'Управление на проследяващи',
    refreshText:
      'Автоматично опресняване (списъкът с потребители се опреснява автоматично на всеки 30 секунди)',
    addText: 'Добавете',
    dataText: 'Получени данни',
    timeText: 'мин',
    hourText: 'часове',
    agoText: ' преди',
    tableEmail: 'Въведете номера на акаунта',
    // searchPlacehold: 'Моля, въведете номера на акаунта си за търсене',
    searchPlacehold: 'Моля, въведете номера на акаунта...',
    pending: 'В очакване',
    approved: 'Одобрено',
    rejected: 'Отхвърлено',
    addFollower: 'Добавете проследяващ',
    editFollower: 'Редактиране на проследяващ',
    tableName: 'Име',
    tableAddTime: 'Добавете време',
    tableStatus: 'Статус',
    tableApproved: 'Одобрено',
    tableReject: 'Отхвърляне',
    tableStartSharing: 'Започнете споделяне',
    tableStopSharing: 'Спиране на споделянето',
    op: 'Оперирайте',
    sharing: 'Споделяне',
    notSharing: 'Не се споделя',
    tableRemove: 'премахнете',
    note: 'Забележка',
    message: 'Съобщение',
    ruleMsgEmailEmpty: 'Моля, въведете имейл за търсене',
    ruleMsgNote: 'Моля, въведете бележка',
    ruleMsgMessage: 'Моля, оставете съобщение',
    ruleMsgEmailCorrect: 'Моля, въведете правилния имейл',
    formAcknowledge:
      'Потвърждавам, че добавянето на проследяващ ще позволи на този потребител да види данните ми',
    sendFollowRequest: 'Изпратете заявка за следване',
    setNote: 'Задайте бележка',
    tipsAcknowledge:
      'Моля, поставете отметка в квадратчето, вие потвърждавате, че добавянето на проследяващ ще позволи на този потребител да вижда моите данни',
    stopSharing: 'Спиране на споделянето',
    startSharing: 'Започнете споделяне',
    removeUser: 'Премахване на потребител',
    confirmStopSharing:
      'Сигурни ли сте, че искате да спрете споделянето на глюкоза с този потребител?',
    confirmStartSharing:
      'Сигурни ли сте да започнете да споделяте глюкоза с този потребител?',
    confirmRemove: 'Сигурни ли сте да премахнете този потребител от списъка?',
    approvedFollower: 'Одобрен прослвдяващ',
    rejectFollower: 'Отхвърляне на проследяващ',
    confirmApproved:
      'Сигурни ли сте, че одобрявате тази заявка за проследяващ?',
    confirmReject:
      'Сигурни ли сте, че ще отхвърлите тази заявка за проследяващ?',
    addTime: 'Добавете време',
    check: 'Проверете',
    remove: 'Премахнете',
    removeUserTitle: 'Сигурни ли сте да премахнете този потребител от списъка?'
  },
  settings: {
    title: 'Настройки на нивото на глюкозата',
    unitSet: 'Настройка на единица',
    targetSet: 'Персонализирана TIR настройка',
    alertSet: 'Настройка на аларми',
    highAlert: 'Висока аларма',
    lowAlert: 'Ниска аларма',
    urgentLow: 'Спешно ниско',
    urgentHigh: 'Спешно високо',
    target: 'Цел'
  },
  pdf: {
    dailyStatistics: 'Дневна статистика',
    title: 'AGP отчет',
    page: 'Страница',
    generated: 'Генерирани',
    lage: 'LAGE',
    mage: 'MAGE',
    modd: 'MODD',
    range: 'Зелена зона',
    timeInRange: 'Зелена зона (TIR)',
    agpTitle: 'Амбулаторен глюкозен профил (AGP)',
    agpSubTitle:
      'AGP е обобщение на стойностите на глюкозата от отчетния период, с медиана (50%) и други процентили, показани така, сякаш са възникнали в един ден',
    dailyTitle: 'Дневен глюкозен профил',
    dailySubTitle:
      'Всеки дневен профил представлява период от полунощ до полунощ.',
    device: 'устройство',
    tDevice: 'Терминално устройство',
    print: 'Печат',
    model: 'Модел',
    deviceSn: 'Сериен номер',
    effectiveData: 'Ефективни данни',
    days: 'Дни',
    appVer: 'Версия на приложението',
    smartPhoneModel: 'Модел смарт телефон',
    osVersion: 'Версия на ОС',
    appSetting: 'Настройка на приложението',
    GoalsforType1andType2Diabetes: 'Цели за диабет тип 1 и тип 2',
    Each1timeinrange15minutes: 'Всеки 1% време в диапазон =~15 минути',
    note: 'Забележка: Единицата % е приложима за стандарта DCCT, а единицата mmol/mol е приложима за стандарта IFCC.',
    DOB: 'Дата на раждане',
    SN: 'SN'
  },
  field: {
    timeCgmActive: 'Време CGM Активен',
    gmi: 'GMI',
    gri: 'GRI',
    eHbA1c: 'eHbA1c',
    avgPerDay: 'ср. Калибриране на ден',
    glucoseAbility: 'Вариабилност на глюкозата',
    lage: 'Lage',
    mage: 'Mage',
    tar: 'TAR',
    tbr: 'TBR',
    calibrations: 'Времена за калибриране'
  },
  agp: {
    agpTitle: 'Амбулаторен глюкозен профил（AGP）',
    centerLine: 'Медиана',
    areaLine: 'Интервал',
    target: 'Целеви диапазон'
  },
  basic: {
    customTir: 'Персонализиран TIR',
    bloodTip: 'Настройки за напомняне за глюкоза',
    bloodUnit: 'Глюкозна единица',
    highTip: 'Предупреждение за висока глюкоза',
    lowTip: 'Предупреждение за ниска глюкоза',
    unitText: 'Автоматично зададено въз основа на региона на страната',
    selectTip:
      'Кликнете върху иконата, за да изберете или премахнете отметката от съответната дата',
    selectAll: 'Изберете Всички'
  },
  report: {
    threeMonth: 'Последните 3 месеца',
    sixMonth: 'Близо 6 месеца',
    yearText: 'Миналата година',
    showAll: 'Покажи всички',
    all: 'Всички',
    selectDate: 'Изберете период от време',
    to: 'към',
    startDt: 'Начална дата',
    endDt: 'Крайна дата',
    betaTest: 'Бета тестване',
    bloodData: 'Данни за глюкоза',
    userCount: 'Потребителски акаунт'
  },
  petDetail: {
    variety: 'Порода',
    type: 'Тип инсулин',
    freq: 'Инсулин честота',
    lente: 'Велики пост',
    insulin: 'Инсулин Glargine',
    pzi: 'PZI',
    nph: 'NPH',
    detemir: 'Detemir'
  },
  pdfReport: {
    title: 'AGP отчет',
    snNumber: 'Сериен номер',
    page: 'Страница',
    createTime: 'Генерирани',
    petInfo: 'Информация за домашни любимци',
    petName: 'Име на домашен любимец',
    birthday: 'Дата на раждане',
    freq: 'Инсулин честота',
    petType: 'Тип домашен любимец',
    age: 'Възраст',
    registerType: 'Тип спринцовка',
    basicBloodData: 'Глюкозни показатели',
    dbText: 'Зелена зона (TIR)',
    target: 'Цели за диабет тип 1 и тип 2',
    recordTime: 'Време за запис',
    tag: 'етикет',
    event: 'Събитие',
    eventDetail: 'Подробности за събитието',
    mulityText: 'Многодневна диаграма на тенденцията на глюкозата',
    mulitySubText:
      'Многодневните профили на глюкозата представляват интервала от време на работа на устройството',
    avageBlood: 'Средна глюкоза',
    bloodText: 'MODD',
    highTip: 'Предупреждение за висока глюкоза',
    lowTip: 'Предупреждение за ниска глюкоза',
    cat: 'котка',
    dog: 'куче',
    country: 'държава',
    insulinDose: 'Доза инсулин',
    weightUnit: 'кг'
  },
  eventDetail: {
  Empty: 'Закуска',
  After_Breakfast: 'След закуска',
  Before_Lunch: 'Преди обяд',
  Breakfast: 'Закуска',
  Lunch: 'Обяд',
  Dinner: 'Вечеря',
  Before_Sleep: 'Преди сън',
  Extra: 'Екстра',
  Short_acting: 'Кратко действащ',
  Pre_mixed: 'Предварително смесен',
  Long_acting: 'Дългодействащ',
  Middle_acting: 'Средно действащ',
  hour: 'ч',
  minutes: 'мин'
}
};
export default bg;
